// DetailStats — section 8. Canonical detail.html lines 591–624.
//
// SNAPSHOT-ONLY per R3 plan. No polling, no websocket subscription,
// no counter animation, no auto-refresh. Counters are reflected
// from PropertyDetailSerializer at fetch time and not updated until
// the user navigates away and back.

const formatCount = (value) => {
  if (value === null || value === undefined) return null;
  const numeric = typeof value === "number" ? value : Number(value);
  if (!Number.isFinite(numeric)) return null;
  return numeric.toLocaleString("uk-UA");
};

const formatDate = (iso) => {
  if (!iso) return null;
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return null;
  return date.toLocaleDateString("uk-UA");
};

function DetailStats({ property }) {
  const views = formatCount(property.views_count);
  const likes = formatCount(property.likes_count);
  const bookmarksUser = formatCount(property.bookmarks_user_count);
  const bookmarksAnon = formatCount(property.bookmarks_anon_count);
  const publishedAt = formatDate(property.created_at);

  const muted = <span className="muted">—</span>;

  return (
    <section className="detail-stats">
      <div className="container">
        <div className="row">
          <ul className="stats-list" aria-label="Статистика оголошення">
            <li className="stat-item">
              <i className="fa-solid fa-eye" aria-hidden="true" />
              <span className="stat-num">{views !== null ? views : muted}</span>
              <span className="stat-label">Переглядів</span>
            </li>
            <li className="stat-item">
              <i className="fa-solid fa-heart" aria-hidden="true" />
              <span className="stat-num">{likes !== null ? likes : muted}</span>
              <span className="stat-label">Лайків</span>
            </li>
            <li className="stat-item">
              <i className="fa-solid fa-bookmark" aria-hidden="true" />
              <span className="stat-num">
                {bookmarksUser !== null ? bookmarksUser : muted}
              </span>
              <span className="stat-label">У обраному</span>
            </li>
            <li className="stat-item">
              <i className="fa-regular fa-bookmark" aria-hidden="true" />
              <span className="stat-num">
                {bookmarksAnon !== null ? bookmarksAnon : muted}
              </span>
              <span className="stat-label">Анонімних збережень</span>
            </li>
            <li className="stat-item">
              <i className="fa-solid fa-calendar" aria-hidden="true" />
              <span className="stat-num">
                {publishedAt !== null ? publishedAt : muted}
              </span>
              <span className="stat-label">Опубліковано</span>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
}

export default DetailStats;
